// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Caa-z","narrowOptionButtons":"Daa-z","noOptions":"Eaa-z"};